parseTokenYYY